DialogEditTipoCtrl.$inject = ['$log', '$scope', '$http', '$timeout'];
export default function DialogEditTipoCtrl($log, $scope, $http, $timeout) {

    var TAG = 'DialogEditTipoCtrl: ';
    var URL_TIPOS_BASE = Sigo.var.path + '/mantenimiento/tipos';

    var vm = this;
    vm.hayInspeciones = Sigo.config['inspecciones']['estado_modulo'];

    vm.model = $scope.model;
    vm.dialogHandler = $scope.dialog;
    vm.cargando = {
        datos: false,
        submit: false
    };
    vm.formDeshabilitado = false;
    vm.opcionesSiONo = [
        {label: StringUtils.ucfirst(Lang.choice('nombres.si', 1)), value: 1},
        {label: StringUtils.ucfirst(Lang.choice('nombres.no', 1)), value: 0}
    ];

    cargarTipo(vm.model.tipoId);

    vm.editarTipo = function (tipo) {
        var url = URL_TIPOS_BASE + '/edit/' + tipo.id;
        var promesa = $http.post(url, tipo);
        vm.cargando.submit = true;
        vm.formDeshabilitado = true;
        promesa.then(function (data) {
            vm.model = data.data;
            vm.dialogHandler.close(tipo);
        }, function () {
            vm.cargando.submit = false;
            vm.formDeshabilitado = false;
        });
    };

    vm.cancelar = function () {
        vm.dialogHandler.cancel();
    };

    function cargarTipo(id) {
        vm.cargando.datos = true;
        vm.formDeshabilitado = true;
        var promesa = $http.get(URL_TIPOS_BASE + '/detalles/' + id);
        promesa.then(function (data) {
            vm.model = data.data;
            vm.cargando.datos = false;
            vm.formDeshabilitado = false;
        });
        //TODO: Cargar los tipos padre

        var promesaTiposPadre = $http.post(URL_TIPOS_BASE + '/datos');
        promesaTiposPadre.then(function (data) {
            var tiposSinElActual = data.data.aaData.filter(function (item) {
                return item.id != id;
            });
            vm.tiposPadre = tiposSinElActual;
        })
    }

    vm.opcionesEsPublica = [
        {label: 'Si', value: 1},
        {label: 'No', value: 0}
    ];
}